module.exports = __webpack_public_path__ + "125b490aea53d38a4695679858557427.jpg";